// {
//   checkedAllValue:'1',
//     checkedAllValueList:[],
//   indeterminate:false,
//   checkedList:[],
//   checkAll:false,
//   dataList:[]
// }
const centerCheckChange = function(e,groupInfo){
  Object.assign(groupInfo, {
    checkedList: e.target.checked ? groupInfo.dataList.map(item=> item.value) : [],
    indeterminate: false,
    checkAll: e.target.checked,
  });
  groupInfo.dataList.forEach(item=>{
    if(item.dataList&&item.dataList.length>0){
      centerCheckChange(e,item)
    }
  })
}
const onCenterCheckGroupChange = function(e,groupInfo,parent){
  groupInfo.indeterminate = !!groupInfo.checkedList.length && groupInfo.checkedList.length < groupInfo.dataList.length;
  groupInfo.checkAll = groupInfo.checkedList.length === groupInfo.dataList.length;
  if(groupInfo.checkedAllValue){
    if(groupInfo.checkAll ){
      groupInfo.checkedAllValueList = [groupInfo.checkedAllValue]
    }else{
      groupInfo.checkedAllValueList = []
    }
  }
  if(parent){
    if( parent.checkedList.indexOf(groupInfo.value)>=0){
      parent.checkedList.splice(parent.checkedList.indexOf(groupInfo.value),1)
    }else{
      if(groupInfo.checkAll){
        parent.checkedList.push(groupInfo.value)
      }
    }
    onCenterCheckGroupChange(e,parent,null)
  }
}
export default {
  centerCheckChange,
  onCenterCheckGroupChange
}